import axios from "axios";
import { localStorageItem } from '../../utils/LocalStorage';
import { KEY_LOCALSTORAGE } from "../../auth/core/_consts";

const API = localStorageItem.get(KEY_LOCALSTORAGE.CONFIGURATION)?.["apiUrl"] || process.env.REACT_APP_WMS_API_URL;
const API_ADMIN = localStorageItem.get(KEY_LOCALSTORAGE.CONFIGURATION)?.["adminUrl"] || process.env.REACT_APP_XADMIN_ENDPOINT;
const API_KE_HOACH = API + "/plan";

export const singleAssignEvaluate = (data: any) => {
  let url = API + `/criteria-assessment/assign`;
  return axios.put(url, data);
};

export const searchDepartments = (params: any) => {
  const url = API_ADMIN + `/departments/search`;
  return axios.get(url, {params});
};

export const deletePhieuNhapKho = (id: string) => {
  const url = `${API_KE_HOACH}/${id}`;
  return axios.delete(url);
};